import React from 'react';
import { formatMoney } from '../../utils/constants';
import { styles } from './styles';

// 항목명 목록
const CATEGORIES = [
  'CPU', '쿨러/튜닝', '메인보드', '메모리', '그래픽카드',
  'SSD', 'HDD', '케이스', '파워', '소프트웨어',
  '모니터', '키보드', '마우스', '사운드바', '스피커',
  'PC헤드셋', '공유기/무선랜', 'IP공유기/허브', '프린터/복합기', '케이블',
  '컨트롤러', '멀티탭', 'ODD', '외장HDD/SSD', 'USB', '기타'
];

function InfoTab({
  formData,
  handleInputChange,
  // 자재 관련
  usedMaterials,
  totalMaterialCost,
  materialCategory,
  handleCategoryChange,
  materialSearchTerm,
  handleMaterialSearchChange,
  handleMaterialKeyDown,
  materialSearchResults,
  selectedMaterialIndex,
  handleSelectMaterial,
  materialQuantity,
  setMaterialQuantity,
  handleDeleteMaterial,
  // 부품비용 수정 관련
  customMaterialCost,
  setCustomMaterialCost
}) {
  // 실제 적용될 부품비용 (수정값 or 자동계산값)
  const effectiveMaterialCost = customMaterialCost !== null ? customMaterialCost : totalMaterialCost;
  // 공임 (기본비용)
  const laborCost = parseFloat(formData.laborCost || 0);
  // 결제 금액 = 부품비용 + 공임
  const paymentAmount = effectiveMaterialCost + laborCost;

  // 부품비용 입력 핸들러
  const handleMaterialCostChange = (e) => {
    const value = e.target.value.replace(/[^\d]/g, '');
    setCustomMaterialCost(value === '' ? null : parseInt(value) || 0);
  };

  return (
    <div style={styles.fadeIn}>
      <div style={styles.formSection}>
        <h4 style={styles.sectionTitle}>작업 내역</h4>
        
        <div style={styles.inputGroup}>
          <label style={styles.label}>접수 내역</label>
          <textarea
            name="receiptDetails"
            value={formData.receiptDetails}
            onChange={handleInputChange}
            style={styles.textarea}
            rows="3"
          />
        </div>

        <div style={styles.inputGroup}>
          <label style={styles.label}>처리 내역</label>
          <textarea
            name="processDetails"
            value={formData.processDetails}
            onChange={handleInputChange}
            style={styles.textarea}
            rows="3"
          />
        </div>

        {/* 사용 자재 섹션 */}
        <div style={styles.inputGroup}>
          <label style={styles.label}>
            사용 자재 
            {usedMaterials.length > 0 && (
              <span style={styles.materialCount}>
                ({usedMaterials.length}건, 합계 {formatMoney(totalMaterialCost)})
              </span>
            )}
          </label>
          
          {/* 자재 검색 입력 */}
          <div style={styles.materialSearchRow}>
            <select
              value={materialCategory}
              onChange={handleCategoryChange}
              style={styles.categorySelect}
            >
              <option value="">항목 선택</option>
              {CATEGORIES.map(cat => (
                <option key={cat} value={cat}>{cat}</option>
              ))}
            </select>
            
            <div style={styles.searchInputWrapper}>
              <input
                type="text"
                placeholder={materialCategory ? "제품명 검색..." : "항목을 먼저 선택하세요"}
                value={materialSearchTerm}
                onChange={handleMaterialSearchChange}
                onKeyDown={handleMaterialKeyDown}
                disabled={!materialCategory}
                style={styles.materialSearchInput}
              />
              
              {/* 검색 결과 풀다운 */}
              {materialSearchResults.length > 0 && (
                <div style={styles.searchDropdown}>
                  {materialSearchResults.map((material, index) => (
                    <div
                      key={`${material.category}-${material.product_name}`}
                      onClick={() => handleSelectMaterial(material)}
                      style={{
                        ...styles.searchDropdownItem,
                        ...(index === selectedMaterialIndex ? styles.searchDropdownItemActive : {})
                      }}
                    >
                      <span style={styles.dropdownProductName}>{material.product_name}</span>
                      <span style={styles.dropdownStock}>재고: {material.total_quantity}개</span>
                      {material.selling_price && (
                        <span style={styles.dropdownPrice}>{formatMoney(material.selling_price)}</span>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
            
            <input
              type="number"
              min="1"
              value={materialQuantity}
              onChange={(e) => setMaterialQuantity(e.target.value)}
              style={styles.quantityInput}
              placeholder="수량"
            />
          </div>

          {/* 사용된 자재 목록 */}
          {usedMaterials.length > 0 && (
            <div style={styles.usedMaterialList}>
              {usedMaterials.map((material) => (
                <div key={material.id} style={styles.usedMaterialItem}>
                  <div style={styles.usedMaterialInfo}>
                    <span style={styles.usedMaterialCategory}>[{material.category}]</span>
                    <span style={styles.usedMaterialName}>{material.product_name}</span>
                    <span style={styles.usedMaterialQty}>× {material.quantity}</span>
                    {material.unit_price && (
                      <span style={styles.usedMaterialPrice}>
                        ({formatMoney(material.unit_price * material.quantity)})
                      </span>
                    )}
                    <span style={{ fontSize: '14px', color: '#999', marginLeft: '8px' }}>
                      [{material.material_id}]
                    </span>
                  </div>
                  <button 
                    onClick={() => handleDeleteMaterial(material.id)}
                    style={styles.usedMaterialDelete}
                    title="사용 취소"
                  >
                    ✕
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <div style={styles.formSection}>
        <h4 style={styles.sectionTitle}>완료 정보</h4>
        <div style={styles.formGrid3}>
          <div style={styles.inputGroup}>
            <label style={styles.label}>완료일</label>
            <input
              type="date"
              name="completionDate"
              value={formData.completionDate}
              onChange={handleInputChange}
              style={styles.input}
            />
          </div>
          <div style={styles.inputGroup}>
            <label style={styles.label}>진행 상태</label>
            <select
              name="progressStatus"
              value={formData.progressStatus}
              onChange={handleInputChange}
              style={styles.input}
            >
              <option value="진행">진행</option>
              <option value="완결">완결</option>
              <option value="미수">미수</option>
              <option value="취소">취소</option>
              <option value="대기">대기</option>
            </select>
          </div>
          <div style={styles.inputGroup}>
            <label style={styles.label}>공임</label>
            <input
              type="text"
              name="laborCost"
              value={formatMoney(formData.laborCost)}
              onChange={handleInputChange}
              style={styles.input}
              placeholder="0"
            />
          </div>
        </div>
        
        {/* 전체비용 표시: 합산부품가격 + 공임 = 결제금액 (한 줄 형태) */}
        <div style={{...styles.inputGroup, marginTop: '16px'}}>
          <label style={styles.label}>전체비용 (부가세 별도)</label>
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '8px',
            padding: '12px 16px',
            backgroundColor: '#f8f9fa',
            borderRadius: '8px',
            border: '2px solid #e8ecef',
            fontSize: '18px',
            fontWeight: '600'
          }}>
            {effectiveMaterialCost > 0 ? (
              <>
                <input
                  type="text"
                  value={formatMoney(effectiveMaterialCost)}
                  onChange={handleMaterialCostChange}
                  style={{
                    border: 'none',
                    background: customMaterialCost !== null ? '#fff3cd' : 'transparent',
                    fontSize: '18px',
                    fontWeight: '600',
                    color: '#2c3e50',
                    width: `${Math.max(80, String(formatMoney(effectiveMaterialCost)).length * 12)}px`,
                    textAlign: 'right',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    outline: 'none',
                    cursor: 'pointer'
                  }}
                  title="클릭하여 수정"
                />
                <span style={{ color: '#7f8c8d', margin: '0 4px' }}>+</span>
                <span style={{ color: '#2c3e50' }}>{formatMoney(laborCost)}</span>
                <span style={{ color: '#7f8c8d', margin: '0 4px' }}>=</span>
              </>
            ) : null}
            <span style={{ color: '#27ae60', fontWeight: '700' }}>{formatMoney(paymentAmount)}</span>
           </div>
          {customMaterialCost !== null && (
            <div style={{ marginTop: '8px', display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{ fontSize: '12px', color: '#856404' }}>
                ⚠️ 수동 수정됨 (자동계산: {formatMoney(totalMaterialCost)}원)
              </span>
              <button
                onClick={() => setCustomMaterialCost(null)}
                style={{
                  fontSize: '12px',
                  padding: '2px 8px',
                  backgroundColor: '#ffc107',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  color: '#856404'
                }}
              >
                복원
              </button>
            </div>
          )}
        </div>
        
        <div style={styles.inputGroup}>
          <label style={styles.label}>비고</label>
          <textarea
            name="notes"
            value={formData.notes}
            onChange={handleInputChange}
            style={styles.textarea}
            rows="2"
            placeholder="추가 메모사항을 입력하세요"
          />
        </div>
      </div>
    </div>
  );
}

export default InfoTab;
